import { useEffect, useRef, useSyncExternalStore } from 'react';

import { realtime, type ConnectionState, type EventHandler } from './client';

/**
 * Подписка на канал на время жизни компонента.
 *
 * Обработчик хранится в ref: он почти всегда замыкает свежие данные
 * (queryClient, идентификаторы), и пересоздавать подписку на каждый рендер
 * незачем — сервер получил бы поток subscribe/unsubscribe.
 */
export function useChannel(channel: string | undefined, handler: EventHandler): void {
  const latest = useRef(handler);

  useEffect(() => {
    latest.current = handler;
  });

  useEffect(() => {
    if (channel === undefined || channel === '') {
      return;
    }

    return realtime.subscribe(channel, (event) => {
      latest.current(event);
    });
  }, [channel]);
}

/** Состояние соединения — для индикатора и страницы статуса. */
export function useConnectionState(): ConnectionState {
  return useSyncExternalStore(
    (listener) => realtime.onStateChange(listener),
    () => realtime.getState(),
    () => 'offline' as const,
  );
}
